<template>
  <div style="display: flex; flex-direction: column; width: 100%;">
    <el-form
        ref="form"
        :model="form"
        :inline="true"
        label-width="120px"
        style="flex: 1;">
      <gj-table
          :index="false"
          name="handleFbaShipment"
          :loading="loading"
          :data="form.items"
          :columns="columns"
          :show-overflow="false"
          :offset-height="48"
          :adaptHeight="true"
          :show-pagination="false">
        <template v-slot:quantity="{ row, index }">
          <el-form-item
              :prop="`items.${index}.quantityShipped`"
              :rules="[
                { required: !areCasesRequired, message: '请输入申报量', trigger: ['blur', 'change'] },
                !areCasesRequired ? $gjReRule(RE.pt, '请输入大于0的整数') : { required: false },
                $gjCustomRule(shippedChangValidator(row.originQuantityShipped))
              ]"
              class="gj-table-item auto-height">
            <gj-input
                v-if="workingStatus && !areCasesRequired"
                v-model="form.items[index].quantityShipped">
            </gj-input>
            <span v-else>{{ row.quantityShipped }}</span>
          </el-form-item>
        </template>
        <template v-slot:quantityInCase="{row, index}">
          <el-form-item
              :prop="`items.${index}.quantityInCase`"
              :rules="[
                  { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
              class="gj-table-item">
            <gj-input
                v-model="form.items[index].quantityInCase"
                @input="setQuantity(row, index)">
            </gj-input>
          </el-form-item>
        </template>
        <template v-slot:box="{row, index}">
          <el-form-item
              :prop="`items.${index}.box`"
              :rules="[
                  { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                  $gjReRule(RE.pt, '请输入大于0的整数')
                ]"
              class="gj-table-item">
            <gj-input
                v-model="form.items[index].box"
                @input="setQuantity(row, index)">
            </gj-input>
          </el-form-item>
        </template>
        <template v-slot:sku="{row}">
          <div><gj-tooltip :text-line="1" :content="row.sku">{{row.sku | defaultShow}}</gj-tooltip></div>
          <div>
            <gj-tooltip
              :text-line="1"
              :content="row.skuName">
            {{row.skuName | defaultShow}}
          </gj-tooltip>
          </div>
        </template>
        <template v-slot:msku="{row}">
          <div><gj-tooltip :text-line="1" :content="row.msku">{{row.msku | defaultShow}}</gj-tooltip></div>
          <div><gj-tooltip :text-line="1" :content="row.asin">{{row.asin | defaultShow}}</gj-tooltip></div>
          <div><gj-tooltip :text-line="1" :content="row.fnsku">{{row.fnsku | defaultShow}}</gj-tooltip></div>
        </template>
        <template v-slot:maxQuantityShipped="{row}">
          <span class="gj-mr10">{{row.maxQuantityShipped | defaultShow}}</span>
        </template>
        <template v-slot:op="{ index }">
          <gj-button
              type="text"
              :disabled="form.items.length === 1"
              @click="deleteItem(index)">
            删除
          </gj-button>
        </template>
      </gj-table>
    </el-form>
    <el-row
        v-show="loadingStep"
        type="flex"
        align="middle"
        justify="center"
        style="margin-top: 10px;">
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          v-if="workingStatus"
          :loading="updateFbaShipmentLoading"
          @click="updateFbaShipment"
      >确认调整</gj-button>
      <gj-button
          type="primary"
          @click="nextStep"
      >下一步</gj-button>
    </el-row>
  </div>
</template>

<script>
  import {
    formDeleteItemMixin,
    formMixin,
    formRuleMixin,
    formValidatorMixin,
    stepsMixin
  } from "../../../../../../../minxins";
  import {getFbaShipmentItems, updateFbaShipment} from "../../../../../../../api/logistics";
  import {isMeaningful, isMeaningless} from "../../../../../../../utils/common";
  import {FbaShipmentEnum} from "../../../../../common/logistics/enum";

  export default {
    name: "app-step-1",
    mixins: [formDeleteItemMixin, formMixin,
      formValidatorMixin, formRuleMixin, stepsMixin],
    props: {
      id: {
        required: true
      },
      shipment: {
        required: true
      }
    },
    created() {
      // 获取货件产品明细
      this.loading = true;
      getFbaShipmentItems({
        fid: this.id,
      })
        .then((data) => {
          if (data) {
            data.forEach(item => item.originQuantityShipped = item.quantityShipped);
          }
          this.form.items = data;
        })
        .complete(() => {
          this.loading = false; this.loadingStep = true;
        });
    },
    data() {
      return {
        columns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'sku', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '150px'},
          {id: 'maxQuantityShipped', header: '建议最大申报量', help: '此数据来源于亚马逊后台【补货】报表中的"最大发货量"数值',
            field: 'slot:maxQuantityShipped', width: '120px', align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', width: '50px', notCustomColumn: true},
        ],
        loading: false,
        updateFbaShipmentLoading: false,
        FbaShipmentEnum: FbaShipmentEnum,
        areCasesRequired: null,
        shipmentStatus: null,
        loadingStep:false
      }
    },
    computed: {
      workingStatus() {
        if (isMeaningless(this.shipmentStatus)) {
          return false;
        }
        return this.shipmentStatus === FbaShipmentEnum.status.WORKING;
      }
    },
    watch: {
      shipment: {
        handler: function (shipment) {
          if (isMeaningless(shipment)) {
            return;
          }
          this.areCasesRequired = shipment.areCasesRequired;
          this.shipmentStatus = shipment.status;
          this.columns = [
            {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
            {id: 'sku', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '200px'},
            {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '150px'},
            this.areCasesRequired ? {id: 'quantity', header: '单箱数量', field: 'slot:quantityInCase', width: '110px'} : null,
            this.areCasesRequired ? {id: 'quantity', header: '箱数', field: 'slot:box', width: '110px'} : null,
            {id: 'quantity', header: '申报量', field: 'slot:quantity',
              help: '在WORKING状态下可更改数量，范围只能是数量的 5% 或 6件，最终调整是否成功，依据亚马逊API返回结果',
              required: this.workingStatus && !this.areCasesRequired,
              width: this.workingStatus && !this.areCasesRequired ? '120px' : '80px',
              align: this.areCasesRequired ? 'right' : 'left'},
            {id: 'maxQuantityShipped', header: '建议最大申报量', help: '此数据来源于亚马逊后台【补货】报表中的"最大发货量"数值',
              field: 'slot:maxQuantityShipped', width: '140px', align: 'right'},
            {id: 'op', header: '操作', field: 'slot:op', width: '50px', notCustomColumn: true},
          ].filter(e => isMeaningful(e));
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      setQuantity(row, index) {
        if (!isNaN(row.quantityInCase) && !isNaN(Number(row.box))) {
          this.form.items[index].quantityShipped = Number(row.quantityInCase) * Number(row.box);
          this.formValidateField(`items.${index}.quantityShipped`);
        } else {
          this.form.items[index].quantityShipped = null;
        }
      },
      updateFbaShipment() {
        if (this.formValidate()) {
          this.updateFbaShipmentLoading = true;
          updateFbaShipment({
            id: this.id,
            updateItems: this.form.items.map(item => ({
              id: item.id,
              msku: item.msku,
              quantityInCase: this.areCasesRequired === FbaShipmentEnum.areCasesRequired.ORIGIN
                ? item.quantityInCase : null,
              quantityShipped: item.quantityShipped
            }))
          })
            .then(() => {
              this.$gjMessage.success('调整成功');
              this.$emit('markUpdate');
            })
            .complete(() => this.updateFbaShipmentLoading = false);
        }
      },
      shippedChangValidator(originQuantity) {
        return (quantity) => {
          if (isMeaningless(quantity)) {
            return null;
          }
          // 原申报量
          const originQuantityShipped = Number(originQuantity);
          // 新申报量
          const quantityShipped = Number(quantity);
          // 已发量
          // const dlShippedQuantity

          const minQuantityShipped = this.getMinQuantityShipped(originQuantityShipped);
          const maxQuantityShipped = this.getMaxQuantityShipped(originQuantityShipped);

          if (quantityShipped !== 0 && (quantityShipped < minQuantityShipped || quantityShipped > maxQuantityShipped)) {
            return `数量超出允许范围，请输入${minQuantityShipped}至${maxQuantityShipped}的值`;
          }
          // 已发量逻辑验证
          // else if (quantityShipped < dlShippedQuantity) {
          //   return {'errorQuantityShipped2': true};
          // }
          return null;
        }
      },
      // 获取申报调整数量
      getShippedChangQuantity(originQuantityShipped) {
        // 调整百分比范围
        const changePerRange = 0.05;
        // 调整数量范围
        const changQuantityRange = 6;
        // 调整数量，取调整百分比和调整数量两者最大，存在小数向下取整
        return originQuantityShipped *  changePerRange > changQuantityRange ? Math.floor(originQuantityShipped * changePerRange) : changQuantityRange;
      },
      // 获取申报量最小值
      getMinQuantityShipped(originQuantityShipped) {
        // 调整数量
        const changQuantity = this.getShippedChangQuantity(originQuantityShipped);
        return originQuantityShipped <= changQuantity ? 1 : Number(originQuantityShipped - changQuantity);
      },
      // 获取申报量最大值
      getMaxQuantityShipped(originQuantityShipped) {
        // 调整数量
        const changQuantity = this.getShippedChangQuantity(originQuantityShipped);
        return Number(originQuantityShipped + changQuantity);
      }
    }
  }
</script>

<style scoped>

</style>














